import { graphql } from "@/lib/gql/__generated__/gql";

export const PLAIN_SETTING_FOR_DESIGN_PLAIN_MUTATION = graphql(/* GraphQL */ `
	mutation PlainSettingForDesignPlainUpdate(
		$input: PlainSettingInput!
		$guestPageVisibilitySettingsInput: GuestPageVisibilitySettingsInput!
		$shouldUpdateGuestPageVisibility: Boolean!
	) {
		plainSettingUpdate(input: $input) {
			userErrors
			plainSetting {
				backgroundImage {
					bucket
					key
					region
					mimeType
					fileName
				}
				backgroundType
				colorBackground
				colorFont
				colorPrimary
				domainName
				fontFamily
				gtmID
				id
				hotelID
				isShowHotelCatchCopy
				isShowHotelKeyVisual
				isShowHotelLogo
				isShowHotelName
				isShowMagazineAbout
				isShowMagazinePlan
				isShowMagazineRoom
				logoImage {
					bucket
					key
					region
					mimeType
					fileName
				}
				logoSize
				widgetDecoration
				reservationComponentType
			}
		}
		# 画面のページの公開状態を変えたときだけ実行する（toGuestPageVisibilitySettingsVariables を参照）
		guestPageVisibilitySettingsUpdate(input: $guestPageVisibilitySettingsInput)
			@include(if: $shouldUpdateGuestPageVisibility) {
			userErrors
			guestPageVisibilitySettings {
				id
				hotelID
				plainVisibility
				magazineVisibility
				snackVisibility
			}
		}
	}
`);
